<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a Maintenance Log
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="device"
                outlined
                v-model="form.device_id"
                :items="deviceItems"
                label="Device"
                prepend-inner-icon="mdi-desktop-tower"
                clearable
                :error-messages="errors.device_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="technician"
                outlined
                v-model="form.technician_id"
                :items="technicianItems"
                label="Technician"
                prepend-inner-icon="mdi-account-wrench"
                clearable
                :error-messages="errors.technician_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="form.log_type"
                outlined
                :items="logTypeItems"
                label="Log Type *"
                prepend-inner-icon="mdi-clipboard-text"
                :error-messages="errors.log_type"
              ></v-select>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                rows="4"
                :error-messages="errors.description"
              ></v-textarea>
            </v-col>
            <v-col sm="12">
              <v-switch
                v-model="form.is_active"
                label="Active"
                inset
                :error-messages="errors.is_active"
              ></v-switch>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Maintenance Log
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "MaintenanceLogCreatePage",
  data() {
    return {
      form: {
        is_active: true,
      },
      deviceItems: [],
      technicianItems: [],
      logTypeItems: [
        { text: 'Maintenance', value: 'maintenance' },
        { text: 'Calibration', value: 'calibration' },
        { text: 'Repair', value: 'repair' }
      ],
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    }
  },
  mounted() {
    this.form.company_id = this.company.id;
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=maintenance_log`)
        .then((masters) => {
          masters = masters.data;
          //Devices
          masters.devices.forEach((device) => {
            this.deviceItems.push({
              id: device.id,
              text: `${device.model_name} - ${device.serial_number}`,
              value: device.id,
            });
          });
          //Technicians
          masters.technicians.forEach((technician) => {
            this.technicianItems.push({
              id: technician.id,
              text: technician.first_name + ' ' + technician.last_name,
              value: technician.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          //window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/maintenance_logs", this.form);
        this.isLoading = false;
        await this.saveUserTimestamp(null, this.form);
        this.$router.push("/maintenance_logs");
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>